// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__2XrCx","vLegacy":"SelectSecondary_vLegacy__30JTW","error":"SelectSecondary_error__3Jcr7","disabled":"SelectSecondary_disabled__3Igi3"};